<ng-template #loading><df-spinner></df-spinner></ng-template>
<!-- display similar skills -->
<ng-container
  *ngIf="displayedSimilarSkills | async as similarSkills; else loading"
>
  <div
    *ngIf="similarSkills.length > 0"
    class="guts-m-t-1 grid__col-sm-10 center-item center-text"
  >
    <ul class="inline-list center-text">
      <li
        *ngFor="let tag of similarSkills"
        class="guts-m-r-1 guts-m-b-1"
        data-dgat="skill-select-items-722"
      >
        <button
          df-button
          dfButtonType="secondary"
          class="btn btn__toggle"
          (click)="onAddSkill(tag, similarSkills)"
          role="checkbox"
          [attr.aria-checked]="tag.isFollowing"
          data-dgat="skill-select-items-940"
        >
          {{ tag.title }}
        </button>
      </li>
    </ul>
  </div>
</ng-container>
<div class="guts-m-t-1 center-item center-text" *ngIf="loadMore">
  <button
    df-button
    dfButtonType="passive"
    (click)="loadMoreSkills()"
    class="guts-m-r-1 __loadMore"
    data-dgat="skill-select-items-710"
  >
    {{ i18n.Onboarding_LoadMore }}
  </button>
</div>
